/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getShopProducts({commit}, lang_id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/' + lang_id, method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    /**
     *
     * @returns {Promise<unknown>}
     */
    createShopProduct({commit}, payload) {
        return new Promise((resolve, reject) => {
            let params = payload.lang_id;
            if(payload.product_id) {
                params = payload.lang_id + '/' + payload.product_id
            }

            axios({url: state.API_URL + '/auth/shop/products/create/' + params, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    storeShopProduct({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    editShopProduct({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/edit/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    updateShopProduct({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/shop/products/update/' + payload.id,
                data: payload.data,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    deleteShopProduct({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    /**
     *
     * @param payload
     * @returns {Promise<unknown>}
     */
    reorderShopProducts({}, payload) {
        return new Promise(() => {
            axios({url: state.API_URL + '/auth/shop/products/reorder', data: payload, method: 'POST'});
        })
    },


    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    storeShopProductReview({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/reviews/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    changeShopProductReviewStatus({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/reviews/change-status', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    deleteShopProductReview({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/reviews/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    storeShopProductReviewReplay({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/reviews-replays/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    changeShopProductReviewReplayStatus({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/reviews-replays/change-status', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    deleteShopProductReviewReplay({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/products/reviews-replays/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
